export const AUTH_ROUTE = '/api/disability/auth';
